export const RecordCreatedAt = {
    LATEST: 1,
    OLDEST: 2,
};
